import { Component, EventEmitter, Input, model, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteUserModal, deleteUserModalOptions } from 'src/app/components/settings/delete-user/delete-user.modal';
import { LoggingService } from 'src/app/services/logging.service';
import { UserOverviewModel } from '../../user-overview.model';
import { IdsForSettingsService, UserInfoModel } from 'src/app/components/settings/ids-for-settings.service';
import { IdentityUserService } from 'src/app/services/identityUser.service';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-userListItem',
  templateUrl: './userlistitem.component.html'
})
export class UserListItemComponent {

  constructor(private modalService: NgbModal,
    private idsForSettingsService: IdsForSettingsService,
    private router: Router,
    private route: ActivatedRoute,
    private loggingService: LoggingService,
    private userService: IdentityUserService,
    private toastService: ToastService,
    private translateService: TranslateService) {
  }
  @Input() organisationUser!: UserOverviewModel | any;
  @Output() requestRefreshUsers = new EventEmitter();

  openDeleteUserModal() {
    const modalRef = this.modalService.open(DeleteUserModal, deleteUserModalOptions);
    modalRef.componentInstance.userGuid = this.organisationUser.id;
    modalRef.componentInstance.userName = this.organisationUser.firstName + " " + this.organisationUser.lastName;
    modalRef.componentInstance.email = this.organisationUser.email;
    modalRef.closed.subscribe({
      next: (deleteSuccesfull) => {
        if (deleteSuccesfull !== true) {
          return;
        }
        // on succesfull delete bubble/emit the refresh up
        this.requestRefreshUsers.emit();
      }
    });
  }

  openUserProfile() {
    if (!this.organisationUser) {
      return;
    }
    let fullNameOfUser = this.organisationUser.firstName + " " + (this.organisationUser.prefix === null ? "" : this.organisationUser.prefix + " ") + this.organisationUser.lastName;
    this.idsForSettingsService.setSelectedUser(new UserInfoModel(this.organisationUser.id, fullNameOfUser))
    this.router.navigate([this.organisationUser.id, 'profile'], { relativeTo: this.route })
      .catch(error => {
        this.loggingService.logException(error);
      });
  }

  async sendEmailReminder() {
    if(!this.organisationUser.isEmailConfirmed) {
      (await this.userService.resendActivationEmail(this.organisationUser.id)).subscribe({
        next: () => {
          let resendInviteUser = this.translateService.instant('Toasts.ResendInviteSuccessful', { email: this.organisationUser.email });
          this.toastService.showSuccessByKey('Toasts.Success', resendInviteUser);
        },
        error: () => {
          this.toastService.showErrorByKey('Toasts.ResendInviteUnsuccessful');
        }
      });
    }
  }

  DisplayEmailNotConfirmed(): boolean {
    return !this.organisationUser.isEmailConfirmed;
  }
}
